import { render, staticRenderFns } from "./StickyButtons.vue?vue&type=template&id=7671f094&"
import script from "./StickyButtons.vue?vue&type=script&lang=js&"
export * from "./StickyButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports